import { all, takeEvery, fork, call, put } from "redux-saga/effects";
import { galleryContentService } from "@iso/services";
import actions from "./actions";

export function* searchGalleryContent() {
  yield takeEvery(actions.SEARCH_REQUEST, function* ({ payload }) {
    const { storeId, latestStatus, page, size, resolve, reject } = payload;
    try {
      const response = yield call(galleryContentService.search, {
        storeId,
        latestStatus,
        page,
        size,
      });
      resolve && resolve(response);
      const rawItems =
        response?.items ?? (Array.isArray(response) ? response : null);
      const items = Array.isArray(rawItems) ? rawItems : [];
      const total = Number(response?.total);
      yield put({
        type: actions.SEARCH_SUCCESS,
        items,
        total: Number.isFinite(total) ? total : 0,
      });
    } catch (e) {
      yield put({ type: actions.SEARCH_ERROR, error: e });
      reject && reject(e);
    }
  });
}

function* registerGalleryContent() {
  yield takeEvery(actions.REGISTER_REQUEST, function* ({ payload }) {
    const { data, resolve, reject } = payload;
    try {
      const response = yield call(galleryContentService.register, data);
      yield put({ type: actions.REGISTER_SUCCESS });
      resolve(response);
    } catch (error) {
      yield put({ type: actions.REGISTER_ERROR, error: error.response });
      reject(error);
    }
  });
}

function* updateGalleryContent() {
  yield takeEvery(actions.UPDATE_REQUEST, function* ({ payload }) {
    const { galleryContentStoreId, data, resolve, reject } = payload;
    try {
      const response = yield call(galleryContentService.update, {
        galleryContentStoreId,
        data,
      });
      yield put({ type: actions.UPDATE_SUCCESS });
      resolve(response);
    } catch (error) {
      yield put({ type: actions.UPDATE_ERROR, error: error.response });
      reject(error);
    }
  });
}

export function* getGalleryContentDetail() {
  yield takeEvery(actions.DETAIL_REQUEST, function* ({ payload }) {
    const { galleryContentStoreId, resolve, reject } = payload;
    try {
      const response = yield call(galleryContentService.getDetail, {
        galleryContentStoreId,
      });
      resolve && resolve(response);
      yield put({
        type: actions.DETAIL_SUCCESS,
        detail: response,
      });
    } catch (e) {
      yield put({ type: actions.DETAIL_ERROR });
      reject && reject(e);
    }
  });
}

function* deleteGalleryContent() {
  yield takeEvery(actions.DELETE_REQUEST, function* ({ payload }) {
    const { galleryContentStoreId, resolve, reject } = payload;
    try {
      const response = yield call(galleryContentService.delete, {
        galleryContentStoreId,
      });
      yield put({ type: actions.DELETE_SUCCESS });
      resolve(response);
    } catch (error) {
      yield put({ type: actions.DELETE_ERROR, error: error.response });
      reject(error);
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(searchGalleryContent),
    fork(registerGalleryContent),
    fork(updateGalleryContent),
    fork(getGalleryContentDetail),
    fork(deleteGalleryContent),
  ]);
}
